import { ɵɵdefineInjectable, ɵɵinject, Injectable, Optional, NgModule } from '@angular/core';
import { Location, CommonModule, TitleCasePipe } from '@angular/common';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, NavigationStart, Router, ActivatedRoute } from '@angular/router';
import { skip, filter } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-translate/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/platform-browser';
import * as ɵngcc4 from '@angular/router';
class NgxTranslateRoutesConfig {
    constructor(enableTitleTranslate, enableRouteTranslate) {
        this.enableTitleTranslate = enableTitleTranslate;
        this.enableRouteTranslate = enableRouteTranslate;
        this.enableRouteTranslate =
            enableRouteTranslate !== undefined ? enableRouteTranslate : true;
        this.enableTitleTranslate =
            enableTitleTranslate !== undefined ? enableTitleTranslate : true;
    }
}

const translatePrefixes = {
    title: 'titles',
    route: 'routes',
};
const lastRouteKey = 'lastLocationPath';

class NgxTranslateRoutesService {
    constructor(translate, location, title, router, activatedRoute, config) {
        this.translate = translate;
        this.location = location;
        this.title = title;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.config = new NgxTranslateRoutesConfig(config === null || config === void 0 ? void 0 : config.enableRouteTranslate, config === null || config === void 0 ? void 0 : config.enableTitleTranslate);
        this.translate.onDefaultLangChange
            .pipe(skip(1))
            .subscribe({ next: () => this.checkConfigValueAndMakeTranslations() });
    }
    init() {
        this.router.events
            .pipe(filter((event) => {
            var _a;
            return event instanceof NavigationEnd ||
                (event instanceof NavigationStart &&
                    event.id === 1 &&
                    ((_a = JSON.parse(localStorage.getItem(lastRouteKey))) === null || _a === void 0 ? void 0 : _a.translatedPath) ===
                        event.url);
        }))
            .subscribe({
            next: (event) => {
                if (event instanceof NavigationStart) {
                    const lastLocationPath = JSON.parse(localStorage.getItem(lastRouteKey));
                    localStorage.removeItem(lastRouteKey);
                    this.router.navigateByUrl(lastLocationPath.path);
                }
                else {
                    this.checkConfigValueAndMakeTranslations();
                }
            },
        });
    }
    checkConfigValueAndMakeTranslations() {
        if (this.config.enableTitleTranslate) {
            this.translateTitle();
        }
        if (this.config.enableRouteTranslate) {
            this.translateRoute();
        }
    }
    translateTitle() {
        let child = this.activatedRoute.firstChild;
        while (child.firstChild) {
            child = child.firstChild;
        }
        const routeTitle = child.snapshot.data.title;
        const appTitle = routeTitle
            ? this.translate.instant(routeTitle)
            : this.title.getTitle();
        this.title.setTitle(appTitle);
    }
    translateRoute() {
        let routeUrl = '';
        const subPaths = this.router.url.split('/');
        subPaths.forEach((subPath) => {
            const translatePath = this.translate.instant(`routes.${subPath}`);
            routeUrl =
                subPath.length > 0
                    ? this.routeUrlConcat(routeUrl, translatePath, subPath)
                    : subPath;
        });
        const lastLocationPath = {
            path: this.location.path(),
            translatedPath: routeUrl,
        };
        localStorage.setItem(lastRouteKey, JSON.stringify(lastLocationPath));
        this.location.replaceState(routeUrl);
    }
    routeUrlConcat(routeUrl, translatePath, subPath) {
        return routeUrl.concat(`/${!translatePath.startsWith(translatePrefixes.route)
            ? translatePath
            : subPath}`);
    }
}
NgxTranslateRoutesService.ɵfac = function NgxTranslateRoutesService_Factory(t) { return new (t || NgxTranslateRoutesService)(ɵngcc0.ɵɵinject(ɵngcc1.TranslateService), ɵngcc0.ɵɵinject(ɵngcc2.Location), ɵngcc0.ɵɵinject(ɵngcc3.Title), ɵngcc0.ɵɵinject(ɵngcc4.Router), ɵngcc0.ɵɵinject(ɵngcc4.ActivatedRoute), ɵngcc0.ɵɵinject(NgxTranslateRoutesConfig, 8)); };
NgxTranslateRoutesService.ɵprov = ɵɵdefineInjectable({ factory: function NgxTranslateRoutesService_Factory() { return new NgxTranslateRoutesService(ɵɵinject(TranslateService), ɵɵinject(Location), ɵɵinject(Title), ɵɵinject(Router), ɵɵinject(ActivatedRoute), ɵɵinject(NgxTranslateRoutesConfig, 8)); }, token: NgxTranslateRoutesService, providedIn: "root" });
NgxTranslateRoutesService.ctorParameters = () => [
    { type: TranslateService },
    { type: Location },
    { type: Title },
    { type: Router },
    { type: ActivatedRoute },
    { type: NgxTranslateRoutesConfig, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTranslateRoutesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.TranslateService }, { type: ɵngcc2.Location }, { type: ɵngcc3.Title }, { type: ɵngcc4.Router }, { type: ɵngcc4.ActivatedRoute }, { type: NgxTranslateRoutesConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();

class NgxTranslateRoutesModule {
    constructor(translateRoutesService) {
        this.translateRoutesService = translateRoutesService;
        this.translateRoutesService.init();
    }
    static forRoot(config) {
        return {
            ngModule: NgxTranslateRoutesModule,
            providers: [{ provide: NgxTranslateRoutesConfig, useValue: config }],
        };
    }
}
NgxTranslateRoutesModule.ɵfac = function NgxTranslateRoutesModule_Factory(t) { return new (t || NgxTranslateRoutesModule)(ɵngcc0.ɵɵinject(NgxTranslateRoutesService)); };
NgxTranslateRoutesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxTranslateRoutesModule });
NgxTranslateRoutesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [TitleCasePipe], imports: [[CommonModule, TranslateModule]] });
NgxTranslateRoutesModule.ctorParameters = () => [
    { type: NgxTranslateRoutesService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTranslateRoutesModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TranslateModule],
                providers: [TitleCasePipe]
            }]
    }], function () { return [{ type: NgxTranslateRoutesService }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxTranslateRoutesModule, { imports: function () { return [CommonModule, TranslateModule]; } }); })();

/*
 * Public API Surface of ngx-translate-routes
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxTranslateRoutesModule, NgxTranslateRoutesService as ɵa, NgxTranslateRoutesConfig as ɵb };

